import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'

@InputType()
export class GetShipEngineLabelArgs extends ActionArgs {
  @Field(() => String)
  labelId: string
}

@InputType()
export class GetShipEngineLabelResult extends ActionArgs {
  @Field(() => String)
  pdf: string

  @Field(() => String)
  png: string

  @Field(() => String)
  zpl: string

  @Field(() => String)
  href: string
}

export interface IGetShipEngineLabel extends IAction<GetShipEngineLabelResult | undefined, GetShipEngineLabelArgs> {}
